import React, { useCallback, useEffect } from 'react';
import { SearchBox, type SearchBoxProps } from '@fluentui/react-components';
import { I18nModel } from '@bingads-webui/copilot-i18n';

import { SearchPlaceholders } from './entity-selection-utils';

interface EntitySearchBoxProps {
  i18n: I18nModel;
  activeTab: keyof typeof SearchPlaceholders;
  disabled?: boolean;
  onChange: SearchBoxProps['onChange'];
  value?: string;
}

export const EntitySearchBox: React.FC<EntitySearchBoxProps> = (props: EntitySearchBoxProps) => {
  const {
    i18n,
    activeTab,
    disabled,
    onChange,
    value,
  } = props;

  const searchBoxRef = React.useRef<HTMLInputElement>(null);
  const searchBoxRefCurrent = searchBoxRef.current;

  const handleSearchBoxClick = useCallback((e: MouseEvent) => {
    if (e.target instanceof Node && searchBoxRefCurrent?.contains(e.target)) {
      searchBoxRef.current?.focus();
    } else {
      searchBoxRef.current?.blur();
    }
  }, [searchBoxRefCurrent]);

  useEffect(() => {
    document.addEventListener('mousedown', handleSearchBoxClick);

    return () => {
      document.removeEventListener('mousedown', handleSearchBoxClick);
    };
  }, [handleSearchBoxClick, searchBoxRefCurrent]);

  return (
    <SearchBox
      placeholder={i18n.getString(SearchPlaceholders[activeTab])}
      onChange={onChange}
      value={value}
      disabled={disabled}
      style={{ width: '100%', cursor: 'text' }}
      ref={searchBoxRef}
      dismiss={{
        style: { display: 'none' }, // Hide the dismiss button
      }}
    />
  );
};
